import * as React from "react";
import { SVGProps } from "react";
const SvgFavourite = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 26.9c.72 0 1.521-.162 2.184-.559l.216-.141c1.9-1.2 3.6-2.6 5.2-4.2 2.4-2.5 4.4-5.8 4.4-9.5C28 8.6 25.3 5 21.2 5 19 5 17 6.2 16 8.1 15 6.2 13 5 10.8 5 6.7 5 4 8.6 4 12.5c0 3.7 2 7 4.4 9.5 1.6 1.6 3.3 3 5.2 4.2.7.4 1.6.7 2.4.7Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFavourite;
